/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerSubmitExplainMutationResponse } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerSubmitExplain";

function getMultiDocumentAgentControllerSubmitExplainUrl() {
  const res = { method: 'POST', url: `/api/v1/multi-document-agent/explain` as const }  
  return res
}

/**
 * @description Explain selected text without loading full document context
 * @summary Submit a text explanation request
 * {@link /api/v1/multi-document-agent/explain}
 */
export async function multiDocumentAgentControllerSubmitExplain(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerSubmitExplainMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getMultiDocumentAgentControllerSubmitExplainUrl().url.toString(), ... requestConfig })  
  return res.data
}